import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import GpsPinIcon from "../../../../../assets/images/searchbars/pin.png";
import AutoCompleteInput from "../../SubComponents/AutoCompleteInput/autocompleteinput";
import HubwayzDestinationAutocomplete from "../AutoCompleteInput/HubwayzDestinationAutocomplete";
import "../../HotelSearchBar/hotelsearchbar.scss";
import AutocompleteinputLDS, {
  parseLocationToString,
} from "../AutoCompleteInput/autocompleteinputLDS";
import MobileDestinationPicker from "./MobileDestinationPicker";
import { isHubwayzHotelsTabEnabled } from "../../../../../features/hubwayzHotelsTab/hubwayzHotelsTabConfig";

const MOBILE_BREAKPOINT = 768;

const DestinationInput = ({
  location,
  setLocation,
  isOrigin,
  isLdsInput,
  isOrganizedTour,
}) => {
  const [isMouseOverInput, setIsMouseOverInput] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== "undefined"
      ? window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT}px)`).matches
      : false
  );
  const [mobilePickerOpen, setMobilePickerOpen] = useState(false);
  const { t } = useTranslation();
  const useHubwayzHotelsDestination =
    !isLdsInput && !isOrigin && isHubwayzHotelsTabEnabled();

  useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT}px)`);
    const handler = () => setIsMobile(mql.matches);
    mql.addEventListener("change", handler);
    return () => mql.removeEventListener("change", handler);
  }, []);

  // Make location disappear
  const handleMouseEnter = () => {
    setIsMouseOverInput(true);
    setIsEditing(true); // For hover remove this and change the onclick to onmouse something
  };

  const handleMouseLeave = () => {
    const googleOutPutRemover = () => {
      // Get all elements with the specified classes
      const elementsToRemove = document.querySelectorAll(
        ".pac-container, .pac-logo, .hdpi"
      );

      // Remove each element
      elementsToRemove.forEach((element) => element.remove());
    };

    // Set editors for false - not editing currently
    if (!isEditing) {
      setIsMouseOverInput(false);
      setIsEditing(false);

      // Remove all google option boxes left that are not being used
      googleOutPutRemover();
    }
  };

  const handleClick = () => {
    if (isMobile && isLdsInput) {
      setMobilePickerOpen(true);
      return;
    }
    handleMouseEnter();
  };

  const showLdsDropdown = isMouseOverInput && isLdsInput && !isMobile;

  return (
    <>
      <div className="hotelSearchBar-item hotelSearchBar-input-location lg:tw-w-[300px]">
        <div
          className="hotelSearchBar-input-content"
          onClick={handleClick}
          onMouseLeave={handleMouseLeave}
        >
          {showLdsDropdown ? (
            <AutocompleteinputLDS
              saveLocationSelection={setLocation}
              location={location}
              isOrigin={isOrigin}
            />
          ) : isMouseOverInput && !isLdsInput && useHubwayzHotelsDestination ? (
            <HubwayzDestinationAutocomplete
              saveLocationSelection={setLocation}
              location={location}
              saveLocationEdit={setIsEditing}
              closeInput={setIsMouseOverInput}
            />
          ) : isMouseOverInput && !isLdsInput ? (
            <AutoCompleteInput
              saveLocationSelection={setLocation}
              location={location}
              saveLocationEdit={setIsEditing}
              closeInput={setIsMouseOverInput}
            />
          ) : (
            <div className="hotelSearchBar-desc-wrapper">
              <div className="hotelSearchBar-icon-wrapper">
                <img
                  className="hotelSearchBar-icon"
                  src={GpsPinIcon}
                  alt=""
                ></img>
              </div>

              <div className="hotelSearchBar-label-wrapper">
                <span className="hotelSearchBar-label1">
                  {isOrigin
                    ? t("hotelsearchbar.selectorigin")
                    : t("hotelsearchbar.selectdestination")}
                </span>

                {location ? (
                <span className="hotelSearchBar-label2">
                  {isLdsInput
                    ? parseLocationToString(location)
                    : location.fullname ||
                      location.name ||
                      location.CITYNAME_HEB ||
                      parseLocationToString(location)}
                </span>
              ) : (
                  <div className="hotelSearchBar-location-required-wrapper">
                    <span className="hotelSearchBar-label2 hotelSearchBar-letter-spacing">
                      {t("hotelsearchbar.selectdestinationdesc")}
                    </span>
                    <input className="hotelSearchBar-location-required" required />
                  </div>
              )}
              </div>
            </div>
          )}
        </div>
      </div>

      {isMobile && isLdsInput && mobilePickerOpen && (
        <MobileDestinationPicker
          onSelect={setLocation}
          onClose={() => setMobilePickerOpen(false)}
        />
      )}
    </>
  );
};

export default DestinationInput;
